import TaskActivityDetail from '@/shared/TaskActivityDetail/TaskActivityDetail';
import { CloseOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { StyledTaskActivityPreview } from './TaskActivityPreview.styled';

export default function TaskActivityPreview({
  taskId,
  activityId,
  taskActivityId,
  miniactivityConf,
  onClose,
}) {
  return (
    <StyledTaskActivityPreview
      className="activity-modal"
      visible={activityId}
      centered
      closable={false}
      width="100%"
      height="100%"
      destroyOnClose
      footer={[
        <Button key="close" onClick={onClose} icon={<CloseOutlined />}>
          Close
        </Button>,
      ]}
    >
      <TaskActivityDetail
        taskId={taskId}
        taskActivityId={taskActivityId}
        activityId={activityId}
        miniactivityConf={miniactivityConf}
        isPreview
      />
    </StyledTaskActivityPreview>
  );
}
